import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Card, CardHeader, CardBody } from 'components/common/card';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableHeadCell,
} from 'components/common/table';
import Input from 'components/common/input';
import Button from 'components/common/button';
import Loader from 'components/common/loader';

import { ActionsContainer, Row } from './elements';

const LocationFinder = ({
  handleInput,
  value,
  enabledLocations,
  locationsFiltered,
  compareLocationVersions,
  loadingValidation,
  closeStorageReport,
  setLocation,
  role,
}) => {
  const locations = locationsFiltered.length ? locationsFiltered : enabledLocations;

  return (
    <Fragment>
      <Card>
        <CardHeader
          title="Filtrar ubicación"
          subtitle="Aquí puedes filtrar por nombre de las ubicaciones que se encuentren habilitadas"
        />
        <CardBody>
          <Input
            input
            type="text"
            label="Nombre de la ubicación"
            primary
            onChange={handleInput}
            value={value}
          />
        </CardBody>
      </Card>

      <Card marginT="50" title="Locaciones habilitadas">
        <CardBody>
          {enabledLocations.length > 0 && role === 'AUDITOR' && (
            <Row>
              <Button sm onClick={closeStorageReport}>
                Cerrar inventario
              </Button>
            </Row>
          )}
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableHeadCell>Nombre</TableHeadCell>
                  <TableHeadCell>Estatus</TableHeadCell>
                  <TableHeadCell>Número de conteos</TableHeadCell>
                  <TableHeadCell>Acciones</TableHeadCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locations.map(location => {
                  const status = new Map([
                    ['ERROR', 'ERROR'],
                    ['SUCCESS', 'EXITOSO'],
                    ['PENDING', 'PENDIENTE'],
                  ]);

                  return (
                    <TableRow
                      key={location.location.id}
                      pending={location.status === 'PENDING'}
                      danger={location.status === 'ERROR'}
                      success={location.status === 'SUCCESS'}
                    >
                      <TableCell>{location.location.tag}</TableCell>
                      <TableCell>{status.get(location.status)}</TableCell>
                      <TableCell>{location.versions}</TableCell>
                      <TableCell>
                        <ActionsContainer>
                          <Button
                            xs
                            onClick={() =>
                              !loadingValidation && compareLocationVersions(location.location.tag)
                            }
                            marginR="20"
                          >
                            {loadingValidation ? <Loader size="15" inverse /> : 'Comparar conteos'}
                          </Button>
                          <Button xs inverse onClick={() => setLocation(location.location.tag)}>
                            Detalle de conteo
                          </Button>
                        </ActionsContainer>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Fragment>
  );
};

LocationFinder.propTypes = {
  handleInput: PropTypes.func.isRequired,
  loadingValidation: PropTypes.bool.isRequired,
  compareLocationVersions: PropTypes.func.isRequired,
  closeStorageReport: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  enabledLocations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  locationsFiltered: PropTypes.array.isRequired,
  setLocation: PropTypes.func.isRequired,
};

export default LocationFinder;
